import PageHeader from "@/components/pageHeader";
import { useRef,useEffect } from "react";
const LeaderSection = ({ leader, index }) => {
  const sectionRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    let raf;
    const update = () => {
      if (!containerRef.current || !sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.max(0, Math.min(1, 1 - (rect.top / (vh * 0.5))));
      const scale = 0.88 + progress * 0.12;
      const radius = 20 - progress * 20;
      containerRef.current.style.transform = `scale(${scale})`;
      containerRef.current.style.borderRadius = `${radius}px`;
    };
    const onScroll = () => { raf = requestAnimationFrame(update); };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, []);

  return (
    <section ref={sectionRef} className="py-4 bg-white">
      <div ref={containerRef} className="overflow-hidden will-change-transform" style={{ transform: "scale(0.88)", borderRadius: "20px" }}>
        <div className={`flex flex-col ${leader.side === "left" ? "lg:flex-row" : "lg:flex-row-reverse"} lg:items-stretch`}>
          {/* Image side - no text overlay */}
          <div className="lg:w-1/2 relative">
            <img src={leader.image} alt={leader.name} className="w-full h-[500px] lg:h-full lg:absolute lg:inset-0 object-cover object-top" />
          </div>
          {/* Content side */}
          <div className="lg:w-1/2 px-8 lg:px-16 py-16 lg:py-20 flex flex-col justify-center bg-[#f5f2ed]">
            <div className="max-w-xl">
              <div className="text-5xl text-[#C4A265] leading-none -mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>&ldquo;</div>
              <p className="text-xl lg:text-2xl text-[#C4A265] italic leading-relaxed" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{leader.quote}</p>
              <div className="text-5xl text-[#C4A265] leading-none mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>&rdquo;</div>
              {leader.bio.map((p, j) => (
                <p key={j} className="font-body text-sm text-[#4A4A4A] leading-relaxed mb-5" style={{ textAlign: "justify" }}>{p}</p>
              ))}
              <div className="mt-8">
                <h3 className="text-2xl text-[#C4A265]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{leader.name}</h3>
                <p className="font-body text-sm text-[#4A4A4A] mt-1">{leader.title}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export const LeadershipPage = () => {
  const leaders = [
    {
      name: "Mr. Ranjit Singh Gill",
      title: "Founder - Gillco Group",
      quote: "At Gillco, we believe that integrity is more than just a word; it is the very foundation upon which we have built lasting relationships with people and families.",
      bio: [
        "The founder of Gillco, Mr. Ranjit Singh Gill is a first-generation entrepreneur whose vision has been instrumental in shaping the urban landscape of Mohali. An alumnus of Government College, Ropar, where he pursued a Bachelor of Arts, Mr. Gill laid the foundation of the organisation with a clear and enduring belief of building not just homes, but communities anchored in trust, integrity and long-term value.",
        "Under his leadership, Gillco has evolved into a credible and respected name in the region, guided by a philosophy that places relationships at the centre of development. His interests in politics, spirituality, and philanthropy have informed a leadership style that is both pragmatic and values-driven. Over the years, his contributions have been recognised by leading institutions, including honours from The Times of India and India Today, where he was awarded Best Builder by the Hon'ble Chief Minister.",
        "As Gillco continues to grow, Mr. Gill remains focused on future-ready development, embracing change, encouraging innovation, and upholding the core values that have defined the group's journey. His vision continues to guide the organisation in building not just spaces, but lasting legacies."
      ],
      image: "/assets/leadership/leader-ranjit.png",
      side: "left"
    },
    {
      name: "Mr. Tejpreet Singh Gill",
      title: "Managing Director - Gillco Group",
      quote: "Gillco's vision for the future is defined by innovation, growth and an unwavering dedication to excellence.",
      bio: [
        "Mr. Tejpreet Singh Gill represents the next phase of leadership at Gillco Group, bringing a global perspective and a forward-looking approach to the organisation's growth. Educated at Bishop Cotton School, Shimla, and a graduate in Business Administration from GD Goenka, Gurgaon, with further academic exposure at Lancaster University, UK, he combines structured business understanding with a contemporary outlook on development.",
        "At Gillco, his vision is anchored in strengthening the group's role as a key contributor to Mohali's emergence as a high-potential urban centre. His approach reflects a conscious blend of tradition and modernity. Under his leadership, Gillco continues to create spaces that go beyond functionality, integrating design, technology, and planning to deliver developments that resonate with both aspiration and practicality. This commitment to quality and innovation has been recognised through several prestigious accolades, including Hindustan Times' Real Estate Developer of the Year, 40 Under 40 Most Influential Leaders (2021-22), India Today's Icons of India (2022), and India's Greatest Brand (2021-22) by AsiaOne.",
        "A fitness enthusiast with a keen interest in paddle, fine timepieces, and performance cars, Mr. Tejpreet Singh Gill brings a disciplined yet dynamic energy to his role. As Gillco expands its footprint, his focus remains on scaling responsibly while upholding the legacy of trust and excellence that defines the group."
      ],
      image: "/assets/leadership/leader-tejpreet.png",
      side: "right"
    },
    {
      name: "Mr. Amandeep Singh Gill",
      title: "Director - Gillco Group",
      quote: "Our goal remains clear: to be an unstoppable force in the real estate industry, creating opportunities and delivering excellence while upholding the trust of our stakeholders.",
      bio: [
        "Mr. Aman Singh Gill brings a globally informed perspective and a dynamic approach to Gillco Group's ongoing expansion. A graduate in International Business from Regent's Business School, London, he combines academic grounding with a keen understanding of evolving market aspirations and consumer behaviour.",
        "At Gillco, his focus remains on sustaining the group's role as a key contributor to Mohali's transformation while continuously elevating the quality and long-term value of its developments. He places strong emphasis on stakeholder relationships, recognising the trust of customers and shareholders as central to the organisation's growth. His contributions have been recognised with honours including the India Today Best Builder Award, presented by the Hon'ble Chief Minister, reflecting the group's continued pursuit of excellence.",
        "An accomplished pickleball player and travel enthusiast with a passion for automobiles, Aman Singh Gill brings an energetic and progressive outlook to the organisation. As Gillco looks ahead, he remains focused on driving sustained growth, creating new opportunities, and reinforcing the trust that defines the brand."
      ],
      image: "/assets/leadership/leader-amandeep.png",
      side: "left"
    },
  ];

  return (
    <div data-testid="v13-leadership-page">
      <PageHeader title="Leadership" subtitle="Meet Our Team" backgroundImage="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=1920" />
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <span className="font-body text-xs tracking-[0.2em] uppercase text-[#C4A265] mb-4 block">Our Leaders</span>
          <h2 className="text-3xl sm:text-4xl text-[#0A0A0A]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Guiding Gillco's Vision</h2>
          <div className="w-16 h-0.5 bg-[#C4A265] mx-auto mt-6" />
        </div>
      </section>
      {leaders.map((leader, i) => (
        <LeaderSection key={i} leader={leader} index={i} />
      ))}

      {/* The Glorious Gillco Team */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <span className="font-body text-xs tracking-[0.2em] uppercase text-[#C4A265] mb-4 block">The Glorious Gillco Team</span>
            <h2 className="text-3xl sm:text-4xl text-[#0A0A0A]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>The Pillars of Excellence</h2>
            <div className="w-16 h-0.5 bg-[#C4A265] mx-auto mt-6" />
          </div>
            <div className="grid md:grid-cols-2 gap-16 lg:ml-40 lg:mr-40">

            {[
              { name: "Ms. Ritika Sachdeva", title: "CEO - Gillco Group", desc: "At the helm of Gillco, Ms. Ritika Sachdeva is a powerhouse in commercial real estate. With a keen eye for emerging markets and a strong ability to forge strategic partnerships, she has been instrumental in Gillco's remarkable growth.", image: "/assets/leadership/team-ritika.png" },
              // { name: "Mr. Sandeep Singh", title: "CEO - Projects", desc: "A leader with unwavering focus and strategic vision, Mr. Sandeep Kumar has transformed Gillco into a market leader. His expertise in strategic acquisitions and development projects has helped redefine urban landscapes.", image: "/team-sandeep.png" },
              { name: "Mr. Daljit Singh", title: "GM - Estates", desc: "With an instinct for market trends and a deep understanding of economic landscapes, Mr. Daljit Singh has navigated Gillco toward consistent success. By fostering a collaborative work environment, he has attracted top talent and propelled the company to new heights.", image: "/assets/leadership/team-daljit.png" },
            ].map((member, i) => (
              <div key={i} className="bg-white overflow-hidden group">
                <div className="overflow-hidden">
                  <img src={member.image} alt={member.name} className="w-full h-[350px] object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-8">
                  <h3 className="text-xl text-[#C4A265] mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{member.name}</h3>
                  <p className="font-body text-xs uppercase tracking-wider text-[#4A4A4A] mb-4">{member.title}</p>
                  <p className="font-body text-sm text-[#4A4A4A] leading-relaxed" style={{ textAlign: "justify" }}>{member.desc}</p>
                </div>
              </div>
            ))}
          </div>

          
        </div>
      </section>
    </div>
  );
};